import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-294c0c3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "preview-custom-fields preview-custom-fields--left",
  "data-testid": "flow-approval-changes"
}
const _hoisted_2 = { class: "preview-cf-title" }
const _hoisted_3 = { class: "preview-cf-grid" }
const _hoisted_4 = { class: "preview-cf-col" }
const _hoisted_5 = { class: "preview-cf-col" }
const _hoisted_6 = { class: "preview-cf-name" }
const _hoisted_7 = { class: "preview-cf-value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "preview-cf-arrow",
  "aria-hidden": "true"
}, "→", -1))
const _hoisted_9 = {
  key: 1,
  class: "preview-custom-fields"
}
const _hoisted_10 = { class: "preview-cf-title" }
const _hoisted_11 = { class: "preview-cf-grid" }
const _hoisted_12 = { class: "preview-cf-col" }
const _hoisted_13 = { class: "preview-cf-col" }
const _hoisted_14 = { class: "preview-cf-name" }
const _hoisted_15 = { class: "preview-cf-value" }

import { computed } from "vue";
import { ElTag } from "element-plus";
import i18n from "@/core/i18n/i18n";
import { summarizeCustomFields } from "@/flow/utils/customFieldSummary";
import { displayValueClass as valueClass } from "@/flow/utils/stepInputSummary";

interface IProps {
  flowSpec: any;
  changes?: Array<{ label: string; before: unknown; after: unknown }>;
  changesTitle?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FlowPreviewCustomFields',
  props: {
    flowSpec: {},
    changes: {},
    changesTitle: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = i18n.global;

const fields = computed(() => summarizeCustomFields(props.flowSpec));
const changes = computed(() => props.changes || []);
const changesTitle = computed(
  () => props.changesTitle || t("Common.FlowSettings")
);
function formatValue(value: unknown): string {
  if (value == null) return t("Common.None");
  if (typeof value === "string") return value;
  try {
    return JSON.stringify(value);
  } catch (_) {
    return String(value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (changes.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(changesTitle.value), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("Common.Name")), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("Common.Value")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changes.value, (change, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(change.label), 1),
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_unref(ElTag), {
                    type: "info",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(formatValue(change.before)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _hoisted_8,
                  _createVNode(_unref(ElTag), {
                    type: "success",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(formatValue(change.after)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (fields.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("Flow.CustomFieldsSet")), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)("Common.Variable")), 1),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)("Common.Value")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (field) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: field.name
              }, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(field.name), 1),
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_unref(valueClass)(field.display))
                  }, _toDisplayString(field.display.text), 3)
                ])
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})